import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import CustomTooltip from '../Controls/Tooltips/CustomTooltip';

interface SectionHeaderProps {
  title: string;
  tooltip?: string;
  children: React.ReactNode;
}

function SectionHeader({ title, tooltip, children }: SectionHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
      <h2 className="text-2xl mb-8 sm:mb-0">
        {title}
        {tooltip && (
          <span className="ml-8 text-slate-500 font-normal text-base">
            <CustomTooltip
              render={() => <FontAwesomeIcon icon={faQuestionCircle} />}
              triggerOnHover
            >
              <span className="text-slate-800">{tooltip}</span>
            </CustomTooltip>
          </span>
        )}
      </h2>
      <div className="flex gap-8 sm:gap-16">{children}</div>
    </div>
  );
}

interface PanelProps {
  children?: React.ReactNode;
  headerChildren?: React.ReactNode;
  title?: string;
  tooltip?: string;
}

export function Panel({ children, headerChildren, title, tooltip }: PanelProps) {
  return (
    <div className="bg-white p-12 rounded-3xl border-2 border-slate-300">
      {title && (
        <SectionHeader title={title} tooltip={tooltip}>
          {headerChildren}
        </SectionHeader>
      )}
      {children && <div className="gap-16 py-12">{children}</div>}
    </div>
  );
}
